export const CIRLICA = {
  alert: {
    alert: 'Ћирилица'
  },
  general: {
    kengur: 'Кенгур',
    kengurFull: 'Кенгур без граница - Друштво математичара Србије'
  },
  meni: {
    homePage: 'Почетна Страна',
    listofStudents: 'Листа ученика',
    listofUser: 'Листа корисника',
    listofSchool: 'Листа школа',
    displayResults: 'Приказ резултата',
    user: 'Корисници',
    students: 'Ученици',
    school: 'Школа',
    complaints: 'Жалбе',
    location: 'Локације',
    category: 'Категорије',
    reviewPapers: 'Преглед радова',
    statistics: 'Статистика',
    resultsStatistics: 'Статистика резултата',
    languageStatistics: 'Статистика на основу  језика',
    genderStatistics: 'Статистика у односу на пол',
    classandCategoryStatistics: 'Статистика за разреде ',
    addNewSchool: 'Додај нову школу',
    addNewStudent: 'Пријави  ученика',
    printList: 'Штампај листу',
    profile: 'Профил',
    menu: 'Мени',
    manage: 'Управљај',
    data: 'Подаци',
    hello: 'Здраво ',
    schools: 'Школе',
    listofSchools: 'Листа школа',
    signStudent: 'Пријави ученика',
    allStudents: 'Сви ученици',
    results: 'Резултати',
    complaintsForStudent: 'Жалбе',
    reviewComplaints: 'Преглед жалби',
    newComplaints: 'Поднеси жалбу',
    settings: 'Подешавања',
    changePassword: 'Промена лозинке',
    logout: 'Одјави се',
    users: 'Корисници',
    importstudents: 'Увоз из Ексела',
    schoolWorkReview: 'Преглед радова школе'
  },
  tabs: {
    all_complaints: 'Све Жалбе',
    unread_by_admin: 'Админ Није Прочитао',
    unread_by_school: 'Школа Није Прочитала',
    admin_responses: 'Одговори Админа',
    unanswered_complaints: 'Нерешене Жалбе',
    finished_complaints: 'Решене жалбе',
    users: 'Корисници',
    allUsers: 'Сви корисници',
    teachers: 'Наставници',
    admins: 'Администратори',
    schools: 'Школе',
    dms: 'ДМС'
  },
  status: {
    read: 'Прочитано',
    unread: 'Није Прочитано'
  },
  pagination: {
    rows_per_page: 'Редова по страни:',
    of: 'од',
    more_than: 'више од',
    moreThan: 'више од',
    rowsPerPage: 'Редова по страници',
    noRowsLabel: 'Нема резултата',
    footerRowSelected: 'Селектован ред'
  },

  dialog: {
    addStudentTitle: 'Додај Новог Ученика',
    schoolLabel: 'Школа',
    studentNameLabel: 'Име и Презиме Ученика',
    genderLabel: 'Пол',
    categoryLabel: 'Категорија',
    classGradeLabel: 'Разред',
    professorLabel: 'Професор',
    languageLabel: 'Језик',
    cancelButton: 'Откажи',
    submitButton: 'Додај',
    schoolName: 'Име Школе',
    editPayment: 'Измени плаћање',
    addPayment: 'Додај плаћање',
    payment: 'Евиденција плаћања',
    male: 'Мушки',
    female: 'Женски',
    serbian: 'Српски (Ћирилица)',
    croatian: 'Хрватски',
    hungarian: 'Мађарски',
    latin: 'Српски (Латиница)',
    romanian: 'Румунски',
    nameRequired: 'Име и презиме су обавезни.',
    genderRequired: 'Пол је обавезан.',
    categoryRequired: 'Категорија је обавезна.',
    gradeError: 'Разред мора бити број између 1 и 12.',
    professorRequired: 'Професор је обавезан.',
    languageRequired: 'Језик је обавезан.',
    selectSchool: 'Изаберите школу',
    confirmDeleteTitle: 'Потврди брисање',
    confirmDeleteMessage:
      'Да ли сте сигурни да желите да обришете овај запис? Ова акција је трајна и не може се поништити.',
    confirmButton: 'Потврди',
    confirmDelete:
      'Да ли сте сигурни да желите да урадите брисање? Ова радња није могуће опозвати.',
    edit: 'Измени',
    no: 'Не',
    yes: 'Да',
    pending: 'На Чекању',
    resolved: 'Решено',
    successTitle: 'Успешно',
    successMessage:
      'Ваша жалба је успешно поднета. Хвала што сте нас обавестили. Професори ће прегледати вашу жалбу и предузети одговарајуће кораке. Бићете обавештени о статусу жалбе у најкраћем могућем року.',
    viewComplaintsButton: 'Погледајте све жалбе',
    okButton: 'ОК',
    resetPasswordTitle: 'Ресетуј лозинку за {{user}}',
    resetPasswordInstruction:
      'Унесите нову лозинку или генеришите насумичну за корисника.',
    newPassword: 'Нова лозинка',
    generatePassword: 'Генериши лозинку',
    generatedPasswordInfo:
      'Можете изменити генерисану лозинку ако је потребно.',
    cancel: 'Откажи',
    confirm: 'Потврди',
    passwordResetSuccess: 'Лозинка је успешно ресетована.',
    passwordResetError:
      'Дошло је до грешке приликом ресетовања лозинке. Молимо покушајте поново.',
    dateLabel: 'Датум',
    classLabel: 'Разред',
    complaintMessageLabel: 'Порука жалбе',
    submitComplaint: 'Поднеси Жалбу',
    complaintSubmissionDetails: 'Детаљи о подношењу жалбе',
    formTitle: 'Форма за Подношење Жалбе',
    successfullyDeleted: 'Успешно обрисано.',
    editComplaint: 'Измени Жалбу',
    loadStudentsError: 'Грешка при учитавању ученика',
    saveError: 'Грешка при чувању',
    saveButton: 'Сачувај',
    schoolRead: 'Школа прочитала',
    schoolUnread: 'Школа није прочитала',
    read: 'Прочитано',
    unread: 'Није прочитано',
    notInComplaintMode:
      'Тренутно није могуће поднети жалбу јер мод жалби није активан.',
    success: {
      complaintSubmitted: 'Жалба је успешно поднета.'
    },
    error: {
      missingFields: 'Недостају обавезна поља.',
      fetchingStudents: 'Грешка при преузимању ученика.',
      submittingComplaint: 'Грешка при подношењу жалбе.',
      invalidEmail: 'Унели сте неисправну имејл адресу.',
      studentRegistrationNotAllowed:
        'Пријављивање ученика није дозвољено у тренутној фази.'
    },
    delete: 'Обриши',
    editSchool: 'Измени школу',
    name: 'Име',
    role: 'Рола',
    remark: 'Напомена',
    saveChanges: 'Сачувај Промене',
    addUser: 'Додај корисника',
    username: 'Корисничко име',
    password: 'Лозинка',
    school: 'Школа',
    notes: 'Напомена',
    sendEmail: 'Пошаљи мејл кориснику',
    save: 'Сачувај',
    enterEmail:
      ' Унесите мејл адресу коју сте пријавили приликом регистрације.',
    email: 'Имејл',
    send: 'Пошаљи',
    close: 'Затвори'
  },
  errors: {
    invalidEmail: 'Унели сте неисправну имејл адресу.',
    required: 'Обавезно поље',
    locationMismatch:
      'Поштански број и град се не поклапају. Молимо вас да исправите податке.',
    saveDataError: 'Грешка приликом чувања података.',
    schoolNameMismatch:
      'Могуће је додавати ученике само за своју школу. Назив школе у фајлу се не поклапа са називом школе која је улогована. ',
    schoolNotExistWarning: 'Школа не постоји у бази. Биће додата нова школа.',
    passwordLength: 'Лозинка мора имати најмање 6 цифара',
    duplicateUserName: 'Корисничко име већ постоји.'
  },
  error: {
    missingFields:
      'Молимо вас да изаберете ученика за ког подносе жалбу и унесете поруку жалбе.',
    fetchingStudents: 'Грешка приликом преузимања ученика или жалби.',
    complaintAlreadyExists: 'Жалба је већ поднета за овог ученика.',
    submittingComplaint: 'Грешка приликом подношења жалбе.'
  },
  success: {
    complaintSubmitted: 'Жалба је успешно поднета'
  },
  login: {
    reqFields: 'Корисничко име и лозинка су обавезна поља',
    reqistrationReq: 'Попуните обавезна поља',
    loginError: 'Погрешна лозинка и/или корисничко име',
    registrationError:
      'Нисте унели исправно званичну е-маил адресу школе . Уколико немате приступ, пријавите проблем на kengur@dms.rs',
    generalError:
      'Школа са унетим корисничким именом већ постоји. Уколико имате проблем, обратите се на мејл: kengur@dms.rs.',
    title: 'Кенгур без граница - Друштво математичара Србије',
    username: 'Корисничко име',
    password: 'Лозинка',
    register: 'Регистрација',
    forgotPassword: 'Заборављена лозинка',
    instructions: 'Упутство за пријаву',
    signInButton: 'Пријави се',
    signIn: 'Пријава',
    registerButton: 'Региструј се',
    noAccount: 'Уколико немате налог, региструјте се!',
    welcomeBack: 'Добродошли назад!',
    welcomeBackText:
      'Унесите корисничко име и лозинку како бисте се пријавили!',
    selectCity: 'Изаберите град',
    selectSchool: 'Изаберите школу',
    schoolName: 'Име школе',
    schoolStreet: 'Улица школе',
    schoolTelephone: 'Број телефона школе',
    teacher: 'Наставник',
    schoolEmail: 'Мејл школе',
    useEmailForRegistration: 'Користите мејл за регистрацију',
    signUpButton: 'Региструј се',
    registrationSuccess: 'Успешна регистрација',
    loginDataSentToEmail:
      'Лозинка и корисничко име су Вам успешно послати на мејл.',
    confirm: 'Потврди',
    addUser: 'Додај корисника',

    generatePassword: 'Генериши лозинку',
    role: 'Улога',
    school: 'Школа',
    notes: 'Напомена',
    sendEmail: 'Пошаљи мејл кориснику',
    cancel: 'Откажи',
    save: 'Сачувај',
    enterEmail: 'Унесите своју имејл адресу:',
    emailRequired: 'Имејл адреса је обавезна',
    resetEmailSent: 'Имејл са инструкцијама за ресетовање лозинке је послат'
  },
  columns: {
    id: 'ИД',
    school: 'Школа',
    location: 'Локација',
    accountNumber: 'Број рачуна',
    paymentDate: 'Датум плаћања',
    statementNumber: 'Број извода',
    student_num: 'Број ученика',
    remark: 'Напомена',
    actions: 'Акције',
    name: 'Име',
    type: 'Тип',
    zipCode: 'Поштански број',
    zipcode: 'Поштански број',
    street: 'Улица',
    telephone: 'Телефон',
    email: 'Имејл',
    professor: 'Професор',
    action: 'Акција',
    gender: 'Пол',
    result: 'Резултат',
    category: 'Категорија',
    class: 'Одељење',
    language: 'Језик',
    point_sum: 'Укупни поени',
    studentCount: 'Број ученика',
    school_id: 'Школски ID',
    student_id: 'ID Студента',
    sender_name: 'Име Пошиљаоца',
    message: 'Порука',
    status: 'Статус',
    school_read: 'Школа Прочитала',
    admin_read: 'Админ Прочитао',
    date: 'Датум',
    schoolName: 'Име школе',
    cityName: 'Име града',
    title: 'Преглед Жалби',
    student: 'Ученик',
    selectClass: 'Изаберите разред',
    admin_response: 'Одговор Админа',
    userName: 'Корисничко име',
    userPass: 'Лозинка',
    isAdmin: 'Администратор',
    userGroup: 'Корисничка група',
    sessionID: 'ИД сесије',
    lastLog: 'Последња пријава',
    userRemark: 'Напомена',
    question: 'Питање',
    lastMessageDate: 'Датум последње поруке'
  },
  filter: {
    filters: 'Филтери',
    export: 'Извоз',
    columns: 'Колоне',
    column: 'Колона',
    print: 'Штампај',
    exportCSV: 'Извези ЦСВ',
    density: 'Густина',
    hideAll: 'Сакриј Све',
    showAll: 'Прикажи Све',
    addFilter: 'Додај Филтер',
    removeAll: 'Уклони Све',
    linkOperator: 'Оператор Повезивања',
    operator: 'Оператор',
    value: 'Вредност',
    valueFilter: 'Вредност филтера',
    input: 'Унос',
    operatorAnd: 'И',
    contains: 'садржи',
    operatorOr: 'Или',
    inputLabelAnd: 'Унос (И)',
    inputLabelOr: 'Унос (Или)',
    addFilterLabel: 'Додај Филтер',
    removeFilterLabel: 'Уклони Филтер',
    clearFilters: 'Очисти Филтере',
    nameColumns: 'Назив колоне',
    searchColumns: 'Претражи колоне',
    equals: 'једнако',
    startsWith: 'почиње са',
    endsWith: 'завршава се са',
    isEmpty: 'је празно',
    isNotEmpty: 'није празно',
    isAnyOf: 'је било који од',
    compact: 'Компактно',
    standard: 'Стандардно',
    comfortable: 'Комфорно',
    city: 'Град',
    school: 'Школа'
  },
  search: {
    placeholder: 'Претрага...'
  },
  table: {
    noRows: 'Нема података за приказ'
  },
  text: {
    welcomeHomePage: 'Добро дошли на почетну страну',
    downloadReports: 'Преузми извештаје',
    studentCountMessage: `Пријавили сте {{count}} ученика`, // Placeholder za broj učenika
    welcome: 'Добродошли {{name}}',
    date: 'Датум',
    studentCount: 'Број пријављених ученика',
    top5Students: 'Топ 5 ученика',
    importantDates: 'Важни датуми',
    polls: 'Анкете',
    vote: 'Гласај',
    reports: 'Извештаји',
    downloadReport: 'Преузми извештај',
    studentResults: 'Резултати ученика',
    schoolPerformance: 'Перформансе школе',
    youAreNotASchoolUser: 'Нисте улоговани као школски корисник'
  },

  profile: {
    title: 'Профил',
    username: 'Корисничко Име',
    name: 'Име',
    email: 'Мејл',
    phone: 'Телефон',
    address: 'Адреса',
    city: 'Град',
    school: 'Школа',
    saveChanges: 'Сачувај Промене',
    changePassword: 'Промени Лозинку',
    currentPassword: 'Тренутна Лозинка',
    newPassword: 'Нова Лозинка',
    confirmNewPassword: 'Потврди Нову Лозинку',
    passwordMismatch: 'Лозинке се не поклапају',
    passwordChangeSuccess: 'Лозинка је успешно промењена',
    passwordChangeError: 'Грешка приликом промене лозинке',
    updateSuccess: 'Профил је успешно ажуриран',
    updateError: 'Грешка приликом ажурирања профила',
    cancel: 'Откажи',
    zipcode: 'Поштански Број',
    professor: 'Професор',
    validationError: 'Ово поље је обавезно.',
    confirmPassword: 'Потврдите лозинку'
  },
  validation: {
    futureDateError: 'Датум не може бити у будућности.',
    fixErrors: 'Исправите грешке пре него што наставите.'
  },
  results: {
    title: 'Резултати',
    tabsLabel: 'Изаберите разред',
    allClasses: 'Сви разреди',
    grade: 'Разред {{grade}}',
    gender: 'Пол',
    all: 'Сви',
    male: 'Мушки',
    female: 'Женски',
    language: 'Језик',
    allLanguages: 'Сви језици',
    serbian: 'Српски',
    english: 'Енглески',
    points: 'Поени',
    name: 'Име',
    grade1: 'Разред',
    noStudents: 'Нема ученика пријављених за овај разред',
    noData: 'Нема података за приказ',
    croatian: 'Хрватски',
    hungarian: 'Мађарски',
    latin: 'Српски (Латиница)',
    romanian: 'Румунски',
    studentsTable: 'Табела ученика',
    accessDenied:
      'Приступ резултатима тренутно није могући јер се такмичење налази у фази која то не омогућава.',
    allSchools: 'Све школе',
    mySchool: 'Моја школа'
  },
  statistic: {
    title: 'Статистика у односу на пол',
    description: 'Преглед статистике у односу на полу',
    averageResultTitle: 'Просечан резултат у односу на пол',
    studentCountTitle: 'Број Ученика у односу на пол',
    legend: 'Легенда',
    male: 'Мушки',
    female: 'Женски',
    gender: 'Пол',
    value: 'Вредност',
    noData: 'Нема података',
    resultStatistic: 'Статистика Резултата',
    generalOverview: 'Општи Преглед',
    grade: 'Разред',
    studentCount: 'Број Ученика',
    averageScore: 'Просечан Резултат',
    totalCount: 'Укупан Број',

    lowestScore: 'Најнижи Резултат',
    highestScore: 'Највиши Резултат',
    totalPoints: 'Укупно Поена',
    noResultMode: 'Тренутно није могуће прегледати статистику резултата.',
    maxScore: 'Највиши Резултат',
    avgScore: 'Просечан Резултат',
    studentCountByLanguage: 'Број Ученика на основу изабраног језика',
    languageTableTitle: 'Табела Броја Ученика на основу изабраног језика',
    language: 'Језик',
    serbian: 'Српски - Ћирилица',
    croatian: 'Хрватски',
    hungarian: 'Мађарски',
    romanian: 'Румунски',
    latin: 'Српски (Латиница)',
    pageTitle: 'Статистика на основу изабраног језика',
    languages: {
      С: 'Српски - Ћирилица',
      Х: 'Хрватски',
      М: 'Мађарски',
      Л: 'Српски - Латиница',
      Р: 'Румунски'
    }
  },
  snackbar: {
    deleteSuccess: 'Ученик је успешно обрисан!',
    addSuccess: 'Ученик је успешно додат!'
  },

  statisticsByLanguage: {
    chartTitle: 'Број Ученика на основу изабраног језика',
    tableTitle: 'Табела Броја Ученика на основу изабраног језика',
    language: 'Језик',
    studentCount: 'Број Ученика',
    noData: 'Нема података'
  },
  alerts: {
    submissionClosed:
      'Пријављивање је завршено и тренутно није могуће додавати или мењати ученике.',
    schoolDeleted: 'Школа је успешно обрисана.',
    schoolSaved: 'Измене су успешно сачуване.',
    studentAdded: 'Ученик је успешно додат!',
    studentDeleted: 'Ученик је успешно обрисан.',
    studentsImported: 'Успешно увезени ученици'
  },
  headers: {
    enrolledStudents: 'Пријављени ученици:',
    total: 'Укупно',
    grade: 'Разред {{grade}}',
    userManagement: 'Управљање корисницима'
  },
  complaints: {
    complaintAlreadyExistsTitle: 'Жалба Већ Постоји',
    complaintAlreadyExistsMessage: 'Жалба је већ поднета за овог ученика.',
    viewAllComplaints: 'Прикажи Све Жалбе',
    administrator: 'Администратор',
    school: 'Школа',
    noActiveMode: 'Тренутно нема активног мода за преглед или подношење жалби.',
    noCreateComplaints:
      'Подношење жалби тренутно није могуће јер се такмичење налази у фази која то не омогућава.',
    noViewComplaints:
      'Прегледање жалби тренутно није могуће јер се такмичење налази у фази која то не омогућава.',
    noViewStatisticsCondition:
      'Преглед статистике тренутно није могућ  јер се такмичење налази у фази која то не омогућава.',
    noComplaintsAllowed: 'Подношење жалби није омогућено у тренутном моду.',
    reviewPending: 'Прегледање је завршено, можете сада подносити жалбе.',
    canSubmitAndEdit: 'Можете подносити, уређивати и прегледати жалбе.',
    reviewOnly:
      'Рок за подношење жалби је истекао. Можете само прегледати постојеће жалбе.',
    noComplaintsInResultsMode: 'Жалбе нису доступне у моду Резултати.',
    complaintDetails: 'Детаљи Жалбе',
    professor: 'Професор',
    message: 'Порука',
    response: 'Одговор Кенгур Администрације',
    noResponse: 'Још увек нема одговора',
    noComplaints: 'Школа још увек није поднела ниједну жалбу',
    date: 'Датум',
    mark_as_read: 'Одговори на жалбу',
    send_response: 'Пошаљи одговор',
    close: 'Затвори',
    all: 'Све',
    pending: 'Непрегледане',
    responded: 'Прегледане',
    title: 'Жалбе',
    allComplaints: 'Све жалбе',
    unansweredComplaints: 'Неодговорене жалбе',
    finishedComplaints: 'Завршене жалбе',
    worksButton: 'Радови',
    studentInfo: 'Информације о ученику',
    acceptComplaint: 'Прихвати жалбу',
    sendResponse: 'Пошаљи одговор',
    markAsRead: 'Обележи као прочитано',
    send: 'Пошаљи',
    yourMessage: 'Ваша порука',
    acceptedComplaintMessage:
      'Поштовани, ваша жалба на рад ученика ИД:{{studentId}} је уважена.',

    clickToView: 'Кликните за преглед жалбе',
    tabsLabel: 'Преглед жалби'
  },

  activeMode: 'Тренутно активна фаза:',
  modes: {
    FLAG_ZALBE: 'Жалбе',
    FLAG_REZULTATI_SKOLA_G: 'Прегледање у току',
    FLAG_REZULTATI: 'Прелиминарни резултати',
    FLAG_FINALE: 'Коначни резултати',
    FLAG_SAKRI_KLJUCEVE: 'Сакриј Кључеве',
    FLAG_ZABRANA: 'Забрана пријављивања ученика',
    FLAG_AUTOMATSKO_POVEZIVANJE: 'Аутоматско повезивање радова'
  },
  noActiveMode: 'Пријављивање у току',
  adminDashboard: {
    adminDashboard: 'Администраторска табла',
    administration: 'Администрација',
    students: 'Ученици',
    schools: 'Школе',
    locations: 'Локације',
    competitionModes: 'Фазе Такмичења',
    users: 'Корисници',
    categories: 'Категорије',
    complaints: 'Жалбе',
    passwordResets: 'Ресетовање Лозинки',
    solutions: 'Решења Такмичења',
    results: 'Резултати',
    genderStatistics: 'Статистика у односу на пол',
    languageStatistics: 'Статистика на основу језика',
    resultsStatistics: 'Статистика Резултата',
    bestResults: 'Најбољи Резултати',
    logout: 'Одјава',
    title: 'Контролна табла',
    studentsCount: 'Укупно ученика',
    total_students: 'Укупно ученика',
    manage_students: 'Управљај ученицима',
    schoolsCount: 'Укупно школа',
    total_schools: 'Укупно школа',
    manage_schools: 'Управљај школама',
    complaintsNoResponse: 'Неодговорене жалбе',
    manage_complaints: 'Управљај жалбама',
    current_competition: 'Тренутни фаза такмичења',
    manage_competition: 'Управљај такмичењем',
    students_by_class: 'Број ученика по разредима',
    gender_distribution: 'Статистика ученика по полу',
    recent_complaints: 'Последње поднете жалбе',
    pending_complaints: 'Неодговорене жалбе',
    current_mode: 'Тренутни фаза',
    mode_name: 'Назив мода',
    status: 'Статус',
    phase_competition: 'Фаза такмичења',
    roles: 'Роле',
    homePage: 'Почетна страница',
    review: 'Преглед',
    manageSolutions: 'Управљање решењима',
    reviewSchools: 'Преглед радова ',
    verifyReviews: 'Провера прегледа',
    resultsByGrade: 'Резултати по разредима',
    reports: 'Извештаји',
    other: 'Остало',
    profile: 'Профил',
    close: 'Затвори'
  },
  roles: {
    title: 'Улоге',
    searchPlaceholder: 'Претражи улоге...',
    addNew: 'Додај нову улогу',
    editTitle: 'Измени улогу',
    addTitle: 'Додај нову улогу',
    nameLabel: 'Назив улоге',
    notesLabel: 'Белешке',
    cancel: 'Откажи',
    save: 'Сачувај',
    edit: 'Измени',
    delete: 'Обриши',
    admin: 'Администратор',
    nastavnikPMF: 'Наставник ПМФ',
    skola: 'Школа',
    dms: 'ДМС',
    DMS: 'ДМС'
  },
  adminModovi: {
    title: 'Управљање фазама Такмичења',
    subtitle: 'Активирај или деактивирај фазу за такмичења.',
    noDescription: 'Нема описа доступног.',
    saveChanges: 'Сачувај промене',
    fetchError: 'Грешка при преузимању фаза:',
    updateError: 'Неуспешна измена мода са ID:',
    saveSuccess: 'Све промене су успешно сачуване.',
    saveError: 'Грешка при чувању промена.',
    cleanArchiveButton: 'Архивирај и очисти све',
    cleanDialogTitle:
      'Да ли сте сигурни да желите да архивирате и очистите све?',
    cleanDialogContent:
      'Сви подаци ће бити архивирани, а табеле ће бити испражњене. Ова акција се не може опозвати.',
    cancel: 'Одустани',
    confirm: 'Потврди',
    cleanSuccess: 'Подaци су успешно архивирани и очишћени.',
    cleanError: 'Дошло је до грешке приликом процеса чишћења.'
  },
  adminschool: {
    addNew: 'Додај нову школу',
    title: 'Администрација школа'
  },
  location: {
    zipcode: 'Поштански број',
    area: 'Општина',
    name: 'Назив',
    actions: 'Акције',
    addLocation: 'Додај Локацију',
    locationDetails: 'Детаљи Локације',
    save: 'Сачувај',
    locationUpdated: 'Локација ажурирана',
    locationAdded: 'Локација додата',
    locationDeleted: 'Локација обрисана',
    errorFetchingLocations: 'Грешка при преузимању локација',
    errorSavingLocation: 'Грешка при чувању локације',
    errorDeletingLocation: 'Грешка при брисању локације',
    manageLocations: 'Управљање Локацијама'
  },
  categories: {
    title: 'Категорије',
    searchPlaceholder: 'Претрага категорија…',
    addNew: 'Нова Категорија',
    edit: 'Уреди',
    delete: 'Обриши',
    editTitle: 'Измени Категорију',
    addTitle: 'Додај Нову Категорију',
    nameLabel: 'Назив Категорије',
    notesLabel: 'Напомена',
    cancel: 'ОдУстани',
    save: 'Сачувај'
  },
  modeDescriptions: {
    FLAG_ZABRANA: 'Завршено пријављивање ученика',
    FLAG_ZALBE: 'Дозвољено подношење жалби',
    FLAG_REZULTATI_SKOLA_G: 'Прегледање у току ',
    FLAG_REZULTATI: 'Прелиминарни резултати',
    FLAG_FINALE: 'Коначни резултати',
    FLAG_SAKRI_KLJUCEVE: 'Сакриј Кључеве',
    FLAG_AUTOMATSKO_POVEZIVANJE: 'Аутоматско повезивање радова'
  },
  review: {
    deleteReview: 'Обриши све радове са сервера',
    grade: 'Разред',
    clearAll: 'Очисти све',
    grade_suffix: 'разред',
    student_count: 'Број ученика',
    total_students: 'Укупан број ученика',
    notificationTitle: 'Обавештење',
    noAccessMessage: 'Немате дозволу за приступ овој страници.',
    closeButton: 'Затвори',
    reviewed_students: 'Прегледани ученици',
    unreviewed_students: 'Непрегледани ученици',
    competition_overview: 'Преглед такмичења',
    unconnected_students: 'Неповезани ученици',
    connected_students: 'Повезани ученици',
    search_students: 'Претрага ученика',
    class: 'Разред',
    movement: 'Померање',

    db_points: 'Поени у бази',
    currentViewer: 'Прегледа',
    noUncheckedStudents: 'Нема непегледаних ученика',
    noCheckedStudents: 'Нема прегледаних ученика',
    connect: 'Повежи',
    disconnect: 'Поново повежи',
    previous: 'Претходна',
    next: 'Следећа',
    work: 'Рад',
    no_more_works: 'Нема више радова за повезивање',
    no_work_for_display: 'Нема радова за приказ',
    disconnect_confirmation: 'Потврда одвезивања',
    disconnect_confirmation_message:
      'Да ли сте сигурни да желите да поново повежете рад овог ученика ?',
    cancel: 'Откажи',
    success_connecting: 'Успешно повезивање!',
    error_connecting: 'Повезивање није успело!',
    success_disconnecting: 'Успешно одвезивање!',
    error_disconnecting: 'Одвезивање није успело!',
    error_occurred: 'Дошло је до грешке!',
    work_number: '{{current}} од {{total}}',
    id: 'ИД',
    school_name: 'Школа',
    scanned_works_count: 'Број скенираних радова',
    connected_works_count: 'Повезани радови',
    action: 'Акција',
    schools_with_works: 'Школе са радовима',
    connecting_works: 'Повезивање радова',
    connect_description: 'Овде можете повезати радове са ученицима.',
    'Povezivanje radova': 'Повезивање радова',
    'Pregledanje u toku': 'Прегледање у току',
    'Završeno pregledanje': 'Завршено прегледање',
    'Provera pregledanja': 'Провера прегледаних радова',

    back: 'Назад',
    finish: 'Заврши',
    text: 'Прегледали сте све радове ове школе, можете завршити прегледање',
    finishReview: 'Заврши прегледање',
    reset: 'Ресетуј',
    all_steps_complete: 'Сви кораци су завршени.',
    searchStudent: 'Претрага ученика',
    studentExam: 'Испит ученика',
    studentInfo: 'Информације о ученику',
    editStudentInfo: 'Промени',
    name: 'Име',
    school: 'Школа',
    location: 'Место',
    professor: 'Професор',
    status: 'Статус',
    working: 'Радим',
    finished: 'Завршено',
    opacity: 'Провидност',
    points: 'Поени',
    confirmReview: 'Потврди прегледање',
    resetReview: 'Поново прегледај',
    confirmResetTitle: 'Поништи преглед?',
    confirmResetMessage:
      'Да ли сте сигурни да желите да поништите све промене?',
    yes: 'Да',
    reviewResetSuccess: 'Успешно поништен преглед!',
    reviewError: 'Дошло је до грешке приликом поништавања прегледа.',
    refreshError: 'Дошло је до грешке приликом освежавања листе ученика.',
    tabs: {
      unreviewed: 'Непрегледани',
      reviewed: 'Прегледани'
    },
    review: 'Прегледај',
    searchStudents: 'Претрага ученика',
    gender: 'Пол',
    male: 'Мушки',
    female: 'Женски',
    language: 'Језик',
    croatian: 'Хрватски',
    serbian: 'Српски',
    totalPoints: 'Укупно поена',
    address: 'Адреса',
    changeSchoolData: 'Промени податке о школи',
    changeStudentData: 'Промени податке о ученику',
    studentWork: 'Рад ученика',
    number: 'Број',
    total: 'Укупно',
    change: 'Измени',
    dialogTitle: 'Упозорење',
    finishedMessage:
      'Школа је већ прегледана од стране {{reviewer}}. Ако наставите, можете пребрисати постојеће резултате.',
    inProgressMessage:
      'Школу тренутно прегледава {{reviewer}}. Ако наставите, може доћи до преклапања.',
    unknownStatusMessage: 'Школа има непознат статус.',
    proceed: 'Настави',
    professor_name: 'Прегледач',
    in_progress: 'У току',
    completed: 'Завршено',
    not_started: 'Није започето',
    schools: 'По школама',
    grades: 'По разредима',
    schoolsTitle: 'Преглед по школама',
    gradesTitle: 'Преглед по разредима',
    search: 'Претражи...',
    review_by_school_title: 'Провера прегледаних радова',

    connect_automatic: 'Повежи аутоматски',
    automatic_connection_report: 'Извештај о аутоматском повезивању',
    connect_manually: 'Ручно повезивање',
    successfully_connected: 'Успешно повезано',
    failed_connections: 'Неуспешна повезивања',
    failed_works: 'Неуспешни радови',
    file: 'Фајл',
    reason: 'Разлог',
    close: 'Затвори'
  },
  language: {
    latin: 'Српски (Латиница)',
    cyrillic: 'Српски (Ћирилица)',
    hungarian: 'Мађарски'
  },
  loading: {
    title: 'Учитавање...',
    description: 'Молимо Вас да сачекате док припремамо податке'
  },
  statistics: {
    genderDistribution: 'Статистика ученика по полу',
    studentByClass: 'Ученици по разредима',
    class: 'Разред',
    numberOfStudents: 'Број ученика',
    date: 'Датум',
    studentCount: 'Број ученика',
    grade: 'Разред',
    averageScore: 'Просечан резултат',
    lowestScore: 'Најнижи резултат',
    highestScore: 'Највиши резултат',
    totalPoints: 'Укупно поена',
    noViewStatisticsCondition: 'Тренутно не можете да видите статистику',
    resultsByGrade: 'Статистика резултата по разреду'
  },
  solutions: {
    save: 'Сачувај',
    cancel: 'Откажи',
    updatedSuccessfully: 'Успешно ажурирано!',
    taskNumber: 'Број',
    points: 'Поени',
    letters: {
      A: 'А',
      B: 'Б',
      V: 'В',
      G: 'Г',
      D: 'Д'
    },
    grade: 'Разред',
    solutions: 'Решења',
    actions: 'Акције',
    errorFetchingSolutions: 'Грешка приликом преузимања решења'
  },
  button: {
    addUser: 'Додај корисника'
  },
  result: {
    title: 'Резултати по разредима',
    allCategories: 'Све категорије',
    exportExcel: 'Експортуј у Ексел',
    exportFiltered: 'Експортуј филтриране',
    resultsByGrade: 'Резултати по разредима',
    generatePDF: 'Генериши PDF',
    gradeTabs: 'Табови за разреде',
    name: 'Име',
    school: 'Школа',
    place: 'Место',
    points: 'Поени',
    category: 'Категорија',
    viewWork: 'Погледај рад',
    pdfFilename: 'Резултати_разред_{{grade}}',
    grade: 'разред',
    searchPlaceholder: 'Претражи ученика...'
  },
  resetPassword: {
    title: 'Ресетовање лозинке',
    newPass: 'Нова лозинка',
    confirm: 'Потврди лозинку',
    resetButton: 'Ресетуј лозинку',
    passwordMismatch: 'Лозинке се не поклапају.',
    successMessage:
      'Успешно сте ресетовали лозинку. Бићете преусмерени на почетну страну.',
    generalError: 'Дошло је до грешке приликом ресетовања лозинке.',
    loading: 'Учитавам...',
    loadingButton: 'Молимо сачекајте...'
  },
  importStudentsDialog: {
    title: 'Увоз ученика',
    uploadPrompt: 'Отпремите Excel фајл са списком ученика:',
    schoolInfo: 'Информације о школи',
    studentsList: 'Списак ученика',
    schoolNotFound: 'Школа није пронађена.',
    read: 'Прочитано',
    unread: 'Непрочитано',
    edit: 'Измени',
    delete: 'Обриши',
    successfullyDeleted: 'Успешно обрисано',
    noStudentsInExcel: 'Не постоје студенти у Excel фајлу.',
    schoolCanBeChanged:
      'Ако школа из Ексел фајла није препозната, можете изабрати одговарајућу школу из листе школа за коју ће бити додати ученици из Ексела.'
  },
  student: {
    name: 'Име и презиме',
    category: 'Категорија',
    grade: 'Разред',
    language: 'Језик',
    gender: 'Пол'
  },
  school: {
    name: 'Назив школе',
    street: 'Улица и број',
    city: 'Место',
    zipcode: 'Поштански број',
    teacher: 'Одговорни наставник',
    phone: 'Телефон',
    email: 'Е-пошта'
  },
  buttons: {
    cancel: 'Откажи',
    save: 'Сачувај',
    chooseFile: 'Изабери фајл',
    noFileChosen: 'Ниједан фајл није изабран'
  },
  messages: {
    studentsAdded: 'Ученици су успешно додати.',
    canEditSchoolData: 'Можете изменити податке о школи.'
  },
  modals: {
    editPayment: 'Измена плаћања',
    addPayment: 'Додавање плаћања'
  },
  filters: {
    location: 'Изабери локацију'
  },
  form: {
    school: 'Школа',
    accountNumber: 'Број рачуна',
    paymentDate: 'Датум плаћања',
    statementNumber: 'Број извода',
    note: 'Напомена',
    location: 'Локација'
  },
  links: {
    downloadTemplate: 'Преузми шаблон за додавање ученика'
  }
};
